import { mergeAll } from 'ramda'
import { createTheme, responsiveFontSizes } from '@mui/material/styles'
import type { Direction, Theme } from '@mui/material'
import { THEMES, themesOptions } from './palette'
import { themeVariants } from './variants'

interface ThemeConfig {
  direction?: Direction
  responsiveFontSizes?: boolean
  roundedCorners?: boolean
  theme?: string
}

export const createCustomTheme = (config: ThemeConfig = {}): Theme => {
  let themePalette = themesOptions[config.theme as string]

  if (!themePalette) {
    console.warn(new Error(`The theme ${config.theme} is not valid`))
    themePalette = themesOptions[THEMES.LIGHT]
  }

  let theme = createTheme(
    mergeAll([
      {},
      themePalette,
      themeVariants,
      {
        ...(config.roundedCorners && {
          shape: {
            borderRadius: 8
          }
        })
      },
      {
        direction: config.direction
      }
    ])
  )

  if (config.responsiveFontSizes) {
    theme = responsiveFontSizes(theme)
  }

  theme.breakpoints.values = {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536
  }

  return theme
}
